// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"481662b3","451":"19e685bb","453":"67e96d72","718":"ac5620ca"}[chunkId] + ".chunk.js";
};